<template>
  <el-button size="mini" :style="{color: 'green'}" @click="handleView">View</el-button>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ColumnViewBtn',
  props: {
    rowId: {
      type: [Number, String],
      required: true
    },
    row: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      route: 'getRouteNameFromOrderType'
    })
  },
  methods: {
    handleView () {
      const type = this.row.type
      const routeName = this.route(type)

      const routeData = this.$router.resolve({ name: 'OrderDetail', params: { routeName: routeName, id: this.rowId } })

      window.open(routeData.href, '_blank')
    }
  }
}
</script>
